module.exports = __webpack_public_path__ + "static/img/4.600efd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/4.png
// module id = w7BR
// module chunks = 2